module.exports = __webpack_public_path__ + "static/media/Vladimir_Slinko.3dc212b6.jpg";